var __rest =
  (this && this.__rest) ||
  function (s, e) {
    var t = {};
    for (var p in s)
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (
          e.indexOf(p[i]) < 0 &&
          Object.prototype.propertyIsEnumerable.call(s, p[i])
        )
          t[p[i]] = s[p[i]];
      }
    return t;
  };
import React from 'react';
import {
  DANGER,
  FADE,
  FLASH,
  LABELED,
  LOOP,
  PROGRESS,
  SUCCESS
} from '../../constants';
import { when } from '../../utils';
import classes from '../../utils/classes';
import cssJoin from '../../utils/cssJoin';
import cssPrefix from '../../utils/cssPrefix';
import withMemoRef from '../../utils/withMemoRef';
/**
 * ProgressBar prefix.
 */
const progressBarPrefix = cssPrefix(PROGRESS);
/**
 * ProgressBar component.
 *
 * @param props ProgressBar properties.
 */
export const ProgressBar = withMemoRef('ProgressBar', (_a, ref) => {
  var {
      className,
      displayValue,
      fade = false,
      flash,
      labeled = false,
      loop = false,
      max = 0,
      purpose,
      value = 0
    } = _a,
    props = __rest(_a, [
      'className',
      'displayValue',
      'fade',
      'flash',
      'labeled',
      'loop',
      'max',
      'purpose',
      'value'
    ]);
  const percentage = Math.round((value * 100) / max);
  return React.createElement(
    'div',
    Object.assign(
      {
        'aria-hidden': 'true',
        className: classes(
          PROGRESS,
          {
            [LABELED]: labeled && !loop,
            [LOOP]: loop,
            [progressBarPrefix(FADE)]: fade,
            [`${purpose}`]: purpose,
            [FLASH]: flash === SUCCESS,
            [cssJoin(FLASH, DANGER)]: flash === DANGER
          },
          className
        )
      },
      Object.assign(Object.assign({}, props), { ref })
    ),
    React.createElement('progress', {
      max: max,
      value: value,
      'aria-valuemax': max,
      'aria-valuemin': 0,
      'aria-valuenow': percentage
    }),
    when(labeled, () =>
      React.createElement(
        'span',
        { 'aria-live': 'polite' },
        displayValue || `${percentage}%`
      )
    )
  );
});
export default ProgressBar;
